import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { createLogger } from 'redux-logger';
import rootReducer from '../_reducers';
const loggerMiddleware = createLogger();

const middlewares = [thunkMiddleware];
if (process.env.NODE_ENV !== `production`) {
    middlewares.push(loggerMiddleware);
}

const store = createStore(
    rootReducer,
    applyMiddleware(
        ...middlewares,
    ),
);

export default store


// WEBPACK FOOTER //
// ./src/_helpers/store.js